// extracted by mini-css-extract-plugin
module.exports = {"iwykk9x":"iwykk9x","b119ch68":"b119ch68"};